import React from 'react';

export default function Task(){
    return(
        <div className='commonbox task'>
            <h1 className='boxheadings'>Eliminate Procrastination<br></br>With Just. Do. It.</h1>
            <img className='iphone' src= {require('./images/todo_mac.png')}></img>
            <p className='app'>Full Stack With Firebase</p><br></br>
            <p className='sw'>Express JS, React JS, Node JS, Firebase</p>
        </div>
    );
}